import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@auth/services/authentication/authentication.service';
import { TerminosCondicionesService } from '@shared/services/terminos-condiciones/terminos-condiciones.service';
import { TranslateService } from '@shared/translate/translate.service';
import { ModalController, LoadingController } from '@ionic/angular/standalone';
import { ConfirmarCambioTerminosComponent } from '@shared/components/confirmar-cambio-terminos/confirmar-cambio-terminos.component';

export const terminosGuard: CanActivateFn = async () => {
  const _tyc = inject(TerminosCondicionesService);
  const _auth = inject(AuthenticationService);
  const _modal = inject(ModalController);
  const _loading = inject(LoadingController);
  const _translate = inject(TranslateService);

  const loading = await _loading.create({
    message: _translate.instant('xCargandoDatos'),
  });
  await loading.present();

  return new Promise<boolean>((resolve) => {
    _tyc.verificarTerminosCondiciones().subscribe({
      next: async (acepto) => {
        await loading.dismiss();

        if (acepto) {
          resolve(true);
        } else {
          const modal = await _modal.create({
            component: ConfirmarCambioTerminosComponent,
            cssClass: 'auto-height',
            backdropDismiss: false,
          });

          await modal.present();
          const { data } = await modal.onWillDismiss<boolean>();

          if (data) {
            const loadingAceptar = await _loading.create({
              message: _translate.instant('xGuardandoDatos'),
            });
            await loadingAceptar.present();

            _tyc.aceptarTerminosCondiciones().subscribe({
              next: async () => {
                await loadingAceptar.dismiss();
                resolve(true);
              },
              error: async () => {
                await loadingAceptar.dismiss();
                _auth.logout();
                resolve(false);
              },
            });
          } else {
            _auth.logout();
            resolve(false);
          }
        }
      },
      error: async () => {
        await loading.dismiss();
        _auth.logout();
        resolve(false);
      },
    });
  });
};
